export enum statusAcronym {
  available = 'AVLB', // Vehicle
  assignedVeh = 'ASSN', // Vehicle
  loadingStartVeh = 'LDNS', // Vehicle
  loadingEndVeh = 'LDNE', // Vehicle
  atPlantVeh = 'ATPL', // Vehicle
  arrival = 'ARRV', // Vehicle
  wash = 'WASH', // Vehicle
  assigned = 'ASSG', // Item
  loadStart = 'LDNG', // Item
  loadEnd = 'LDNE', // Item
  tripStart = 'TJST', // Item
  onJobSite = 'OJOB', // Item
  unloadStart = 'UNLD', // Item
  unloadEnd = 'UNLE', // Item
  toPlant = 'TOPL', // Item
  completed = 'CMPL', // Item
  cancelled = 'CNCL', // Item
  toBeConfirmed = 'TBCL', // Item
  notStarted = 'NOST', // Item
  loadOnHold = 'HOLI', // Item
  orderOnHold = 'HOLD', // Order
  blocked = 'BLCK', // Order
  inWaitingList = 'WTLS', // Order
  confirmed = 'CONF', // Order
  callToConfirm = 'CTCO', // Order
  inprocess = 'INPC', // Order
  toBeConfirmedHdr = 'TBCO', // Order
  cancelledHdr = 'CNCO', // Order
  completedHdr = 'CMPO', // Order
  advanceBookingHdr = 'ADBO', // Order
  renegotiatedHdr = 'RNGT', // Order,
  relOrderHold = 'RELH', // Order
  assignedOrder = 'ASSO', // Order
}

export enum statusIndex {
  assigned = 1,
  loadStart,
  loadEnd,
  tripStart,
  onJobSite,
  unloadStart,
  unloadEnd,
  toPlant,
}

export enum statusVehicle {
  available = 1,
  atPlant = 11,
  deadhead = 13,
  away = 14,
  wash = 15,
}

export enum statusVehicleAcronym {
  available = 'AVLB',
  atPlant = 'ATPL',
  deadhead = 'DEAD',
  away = 'AWAY',
  wash = 'WASH',
}

export enum statusVehicleExtraEdge {
  tripStart = 'TJST',
  onJobSite = 'OJOB',
  unloadStart = 'UNLD',
  toPlant = 'TOPL',
  maintenance = 'MAIN',
  washing = 'UNLE',
}

export enum statusProductionOrder {
  created = 10,
  released = 20,
  sent = 30,
  queued = 40,
  inprocess = 50,
  partiallynotified = 60,
  plantstop = 70,
  notified = 80,
  reused = 90,
}

export enum statusVehicleColor {
  available = 'available',
  delayed = 'delayed',
  warning = 'warning',
  inprocess = 'inprocess',
}

export const StatusInProces: string[] = [
  statusAcronym.assigned,
  statusAcronym.loadStart,
  statusAcronym.loadEnd,
  statusAcronym.tripStart,
  statusAcronym.onJobSite,
  statusAcronym.unloadStart,
  statusAcronym.unloadEnd,
  statusAcronym.toPlant,
];
export const StatusCompleted: string[] = [statusAcronym.completed, statusAcronym.completedHdr];
export const StatusCanceled: string[] = [statusAcronym.cancelled, statusAcronym.cancelledHdr];
export const StatusNotStart: string[] = [statusAcronym.confirmed, statusAcronym.notStarted];
export const StatusToBeConf: string[] = [statusAcronym.toBeConfirmedHdr, statusAcronym.toBeConfirmed];
export const StatusHold: string[] = [statusAcronym.loadOnHold, statusAcronym.orderOnHold];

export enum PlantStatusEnum {
  Operational = 'OP',
  Closed = 'CL',
}

export enum ContractStatusIds {
  OPEN = 1,
  NVAL = 2,
  COMP = 3,
  CANC = 4,
  DRFT = 5,
  INRW = 6,
}
